export default "__VITE_ASSET__2JR58t0N__"